import { render, staticRenderFns } from "./point-reward.vue?vue&type=template&id=abe79ae2&scoped=true"
import script from "./point-reward.vue?vue&type=script&lang=js"
export * from "./point-reward.vue?vue&type=script&lang=js"
import style0 from "./point-reward.vue?vue&type=style&index=0&id=abe79ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe79ae2",
  null
  
)

export default component.exports